module.exports = __webpack_public_path__ + "static/media/md-notifications-off.fa53fc0e.svg";